<template>
    <MiniModalCustom
        :is-open="props.show"
        @close="emit('close')"
        :title="`Edit ${props.clip?.title}`"
    >
        <div class="grid grid-cols-[1fr_2fr] gap-4 items-center mt-6">
            <div>Position</div>
            <app-input
                v-model="localValue.position"
                type="number"
                placeholder="Position"
                step="0.01"
            >
            </app-input>
            <div>Start</div>
            <app-input
                v-model="localValue.start"
                type="number"
                step="0.01"
                placeholder="Start"
                :max="props.clip?.duration"
            >
            </app-input>
            <div>End</div>

            <app-input
                v-model="localValue.end"
                type="number"
                step="0.01"
                placeholder="End"
                :max="props.clip?.duration"
            >
            </app-input>
            <div></div>
            <div class="flex gap-2 mt-4">
                <app-button
                    @click="updateClip"
                    class="
                        bg-primary
                        rounded-lg
                        text-white
                        flex
                        items-center
                        gap-1
                    "
                >
                    Update
                </app-button>
                <app-button @click="emit('close')">Cancel</app-button>
            </div>
        </div>
    </MiniModalCustom>
</template>

<script setup>
import { watch, computed, reactive, defineProps, defineEmits } from "vue";

const emit = defineEmits(["close", "update"]);

const props = defineProps({
    clip: {
        type: Object,
    },
    show: {
        type: Boolean,
        default: false,
    },
});

const localValue = reactive({ ...props.clip });
// Watch for changes to the clip prop to reset localValue if clip changes
watch(
    () => props.clip,
    (newClip) => {
        Object.assign(localValue, newClip);
    }
);

function updateClip() {
    emit("update", { ...localValue });
}
</script>
